import { render, staticRenderFns } from "./benefits-withBorder.vue?vue&type=template&id=2c2035c0&"
import script from "./benefits-withBorder.vue?vue&type=script&lang=js&"
export * from "./benefits-withBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports